/** New Front parity: standalone leaf after Data Export; the `tools/` prefix remains URL-only. */
export const platformActionNavItems = [
  {
    labelKey: 'platformActions.nav.label',
    icon: 'clipboard-check',
    iconWeight: 'light' as const,
    to: { name: 'PlatformActions' },
    navKey: 'platformActions',
    // The private pilot flag. `useNavVisibility`'s `flag` control already carries the sysadmin
    // bypass the rollout plan assumes, so no extra gating is written here.
    // Literal-narrowed so app wiring verifies this inferred contribution against `NavItem`
    // without reversing the enforced app -> feature dependency direction for a type import.
    visibility: { control: 'flag' as const, id: 'platform_actions' },
  },
]
